import sendPrompt from '@/redux/actions/pieveActions/sendPrompt.js';

/**
 * Answers a conversation's connection card and continues the conversation, the way the earlier
 * frontend did: a run started with `eventUpdate` merges `patch` into the card event and hands Pieve
 * `patch.summary` as the person's hidden message (`POST /v1/pieve/threads/:threadId/runs`). When the
 * same run left another connection card open, the API only records this one and starts no run until
 * that one is answered too.
 *
 * `optimistic` shows the outcome on the card before the server answers and takes it back if the run
 * does not start. It is off when the card already carries the outcome, as after a provider sign-in,
 * where the OAuth callback recorded it: taking it back would erase the server's answer.
 */
const answerConnectionCard = ({ threadId, interactionId, patch, optimistic = true }) => {
  return async (dispatch) => {
    if (optimistic) {
      dispatch({ type: 'RESPOND_CONNECTION_OPTIMISTIC', payload: { outcome: patch.outcome, meta: { threadId, interactionId } } });
    }

    const res = await dispatch(sendPrompt({ threadId, eventUpdate: { eventId: interactionId, patch } }));

    if (res?.success === false && optimistic) {
      dispatch({ type: 'RESPOND_CONNECTION_FAIL', payload: { outcome: patch.outcome, meta: { threadId, interactionId } } });
    }

    return res;
  };
};

export default answerConnectionCard;
